<template>
    <HeroCarousel :slidesBackground="slides.background">
        <template v-for="i in slidesNumber" #[`slide${i}`]>
            <TotemIntro :key="i" :type="slides.introType[i-1]" v-on:on-play-video="openVideoModal()">
                <template #title>
                    <span v-html="$t('Hero.slide_' + i + '_title_' + $totemLang + (i === 1 ? '_9_4_25' : '_10_3_25'))" />
                </template>
                <template #description>
                    <span v-html="$t('Hero.slide_' + i + '_description_' + $totemLang + (i === 1 ? '_9_4_25' : '_10_3_25'))" />
                </template>
                <template #buttons>
                    <TotemButton v-if="i===2" icon="arrow-right" iconPosition="right" color="hero" @click="openCta2" :label="$t('Hero.slide_' + i + '_button_' + $totemLang + '_10_3_25')" />
                    <TotemButton v-else-if="i===3" icon="arrow-right" iconPosition="right" color="hero" @click="openCta3" :label="$t('Hero.slide_' + i + '_button_' + $totemLang + '_10_3_25')" />
                    <template v-else>
                        <TotemRouterLink
                            v-if="slides.buttonLink[i-1].name !== ''"
                            color="hero"
                            :to="slides.buttonLink[i-1]"
                            :label="$t('Hero.slide_' + i + '_button_' + $totemLang + '_10_3_25') "
                        />
                        <TotemRouterLink
                            color="transparent"
                            :to="slides.secondaryButtonLink[i-1]"
                            :label="$t('Hero.slide_' + i + '_button_secondary_' + $totemLang + '_10_3_25')"
                            v-if="translationExist('Hero.slide_' + i + '_button_secondary_' + $totemLang + '_10_3_25')"
                        />
                    </template>
                </template>
                <template #image>
                    <div class="intro__image-box" :class="{'extra-margin': i === 1 && $totemLang === 'fi'}">
                      <img :src="require('@/assets/images/hero/hero-image-0' + i + '-' + $totemLang +'.png')" alt="" class="intro__image"/>
                    </div>
                </template>
                <template #video>
                    <img :src="require('@/assets/images/hero/video-screen-0' + i + '-'+ $totemLang + '.png')" alt="" class="intro__video-thumbnail" @click="openVideoModal"/>
                </template>
            </TotemIntro>
        </template>
        <HeroVideoModal :videoSrc="slides.videoSrc" />
        </HeroCarousel>
</template>

<script>
    import HeroCarousel from 'components/landingpage/hero/HeroCarousel'
    import HeroVideoModal from '@/components/landingpage/hero/HeroVideoModal'
    import { heroDataHelper } from 'components/landingpage/hero/heroDataHelper'

    export default {
        name: 'hero-logged-cyber-security',
        components: { HeroCarousel, HeroVideoModal },
        mixins: [heroDataHelper],
        methods: {
            openCta1 () {
                window.open(this.$t('Hero.slide_1_button_link_fi_10_3_25'), '_blank')
            },
            openCta2 () {
                window.open(this.$t('Hero.slide_2_button_link_fi_10_3_25'), '_blank')
            },
            openCta3 () {
                window.open(this.$t('Hero.slide_3_button_link_fi_10_3_25'), '_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .extra-margin {
        margin-bottom: 71px;
    }
</style>
